/**
 * Returns the main website URL.
 *
 * It depends on MAIN_WEBSITE_URL being set.
 *
 * e.g. in production, this will be https://www.secondnature.io
 * Locally, this will be http://localhost:3000
 *
 * @returns {string} The absolute base URL.
 */
export const getAbsoluteBaseURL = (): string => {
  if (!process.env.MAIN_WEBSITE_URL) {
    throw new Error('MAIN_WEBSITE_URL not set');
  }
  return process.env.MAIN_WEBSITE_URL;
};
